import {
  DeleteAllLossSetScenariosRequestDto,
  DeleteLossSetScenariosResponseDto,
} from 'src/app/api/generated/api.generated'

export function toDeleteAllLossSetScenariosRequest(
  autoDelete: boolean,
): DeleteAllLossSetScenariosRequestDto {
  return { autoDelete }
}

export function fromDeleteLossSetScenariosResponse(dto: DeleteLossSetScenariosResponseDto): {
  deletedScenarioIds: string[]
  failedScenarioIds: string[]
} {
  return {
    deletedScenarioIds: dto.deletedScenarioIds.map((id) => `${id}`),
    failedScenarioIds: dto.failedScenarioIds.map((id) => `${id}`),
  }
}
